/**
 * Capitalize the first letter of each whitespace-separated string
 */
export function capitalizeEachFirstLetter(str: string): string {
  return str
    .toLowerCase()
    .replaceAll(/[\s_]+/gu, ' ')
    .replaceAll(/(^\w|\s\w)/gu, (firstLetter) => firstLetter.toUpperCase());
}
